export default __webpack_public_path__ + "static/media/ic24_fct_Snapchat.3bb0e8b4.svg";